import BaseService from './BaseService';
import entities from 'src/config/entities';

class OrganizationService extends BaseService {

  constructor() {
    super({ entity: entities.ORGANIZATION });
  }

  async getById(jobId) {
    return super.getById(jobId, {
      'with': 'organisation_names,organisation_info,organisation_segments'
    });
  }

  mergeOrganization(orgId, data) {
    return this.instance.put(`${orgId}/merge`, data);
  }

  createInfo(orgId, data) {
    return this.instance.post(`${orgId}/info`, data);
  }

  updateInfo(orgId, data) {
    return this.instance.put(`${orgId}/info/${data.id}`, data);
  }

  deleteInfo(orgId, data) {
    return this.instance.delete(`${orgId}/info/${data.id}`, data);
  }

  createName(orgId, data) {
    return this.instance.post(`${orgId}/names`, data);
  }

  updateName(orgId, data) {
    return this.instance.put(`${orgId}/names/${data.id}`, data);
  }

  deleteName(orgId, data) {
    return this.instance.delete(`${orgId}/names/${data.id}`, data);
  }

}

export default new OrganizationService();
